import axiosApi from '../../kits/axiosApi';

// initial state
const state = {
};

// getters
const getters = {
};

// actions
const actions = {
    getActionList({ rootState }, params) {
        let aj_host = rootState.aj_host;

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + '/weapp/master/audit/action/list', { params })
                .then((res) => {
                    resolve(res.data.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    exportActionList({ rootState }, params) {
        let aj_host = rootState.aj_host;

        return new Promise((resolve, reject) => {
            axiosApi({
                method: 'get',
                url: aj_host + '/weapp/master/audit/action/export',
                params: params,
                responseType: 'blob'
            })
                .then((res) => {
                    resolve(res.data)
                })
                .catch((err) => {
                    reject(err)
                })
        });
    },
};

// mutations
const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
